export default class Transform {
  static createMultipartFormData (formAndFileData) {
    let fd = new FormData()
    fd.append('form_data', JSON.stringify(formAndFileData.form_data))
    for (let fileId in formAndFileData.form_files) {
      for (let file of formAndFileData.form_files[fileId]) {
        fd.append(fileId, file)
      }
    }
    return fd
  }
}
